import { render, staticRenderFns } from "./ChemUCI51lbA5_Q11b.vue?vue&type=template&id=713e4798&"
import script from "./ChemUCI51lbA5_Q11b.vue?vue&type=script&lang=js&"
export * from "./ChemUCI51lbA5_Q11b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})
